<template>
  <div class="info-end">
    <div class="banner-item">
      <Theme @theme="setTheme" />
    </div>
    <div class="banner-item" v-if="siteSettings">
      <div class="text">
        <h4>{{ siteSettings.site_name }}</h4>
        <p>{{ siteSettings.site_description }}</p>
        <p v-if="!siteSettings.futurePickup && openNow">We close at {{ ct }}.</p>
        <p v-if="!siteSettings.futurePickup && !openNow">We open again {{ ot }}.</p>
      </div>
      <div class="user-icon" @click="accountOpen">
        <font-awesome-icon :class="user.fname ? 'active icon' : 'icon'" icon="user" />
        <div v-if="user.fname">Hi, {{ user.fname }}</div>
        <div v-if="!user.fname">Sign In</div>
      </div>
    </div>
  </div>
  <div class="parent" :class="{ closed: !openNow }">
    <div v-if="openNow" class="info">
      <img v-if="siteSettings.logo" :src="siteSettings.logo.logo" id="img" :class="logoClass" />
    </div>
    <div v-else class="closed-inner">
      <h1>Site is currently closed</h1>
      <p v-if="!siteSettings.futurePickup">We open again {{ ot }}</p>
    </div>
  </div>
  <UserModal :open="showUserModal" />
  <UserAccountModal :open="showUserAccountModal" :account="user" v-if="user.fname" />
</template>

<script>
import { mapGetters } from "vuex";
import UserModal from "../User/UserModal.vue";
import UserAccountModal from "../User/UserAccountModal.vue";
import { Theme } from "@monolith/components";

export default {
  data() {
    return {
      companyName: window.localStorage.getItem("companyName"),
      sites: JSON.parse(window.localStorage.getItem("sites")),
      site: window.localStorage.getItem("site"),
      showUserModal: false,
      showUserAccountModal: false,
      shops: JSON.parse(window.localStorage.getItem("shops")),
      days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
      theme: window.localStorage.getItem("theme"),
      openNow: true,
      ot: this.$hours.openTime(),
      ct: this.$hours.closeTime(),
    };
  },
  components: {
    UserModal,
    UserAccountModal,
    Theme,
  },

  async mounted() {
    if (localStorage.getItem("userID")) {
      await this.$store.dispatch("setUser");
    }
    if (this.futurePickup) {
      this.$hours.alwaysOpen = true;
      this.openNow = true;
    }
  },

  computed: {
    ...mapGetters({
      user: "user",
      siteSettings: "siteSettings",
      getTodayHours: "getTodayHours",
      currentTime: "getCurrentTime",
      getTheme: "getTheme",
      futurePickup: "futurePickup",
      getHours: "getHours",
    }),

    isDark() {
      let CurrentTheme = window.matchMedia("(prefers-color-scheme: dark)").matches;
      let foundTheme = false;
      if (this.getTheme === "os") {
        foundTheme = CurrentTheme;
      } else if (this.getTheme === "dark") {
        foundTheme = true;
      } else if (this.getTheme === "light") {
        foundTheme = false;
      }
      return foundTheme;
    },

    logoClass() {
      let useDark = this.theme === "dark" || (this.theme === "os" && window.matchMedia("(prefers-color-scheme: dark)").matches);
      return this.siteSettings.logo && this.siteSettings.logo.invert === true && useDark ? "dark" : "light";
    },
  },
  methods: {
    setTheme(theme) {
      this.theme = theme;
    },
    accountOpen() {
      Object.keys(this.user).length > 0 ? (this.showUserAccountModal = !this.showUserAccountModal) : (this.showUserModal = !this.showUserModal);
    },
  },
  watch: {
    user: {
      handler() {
        if (Object.keys(this.user).length > 0 && this.user.settings.theme) {
          document.documentElement.classList.add(`${this.user.settings.theme}-theme`);
        } else {
          document.documentElement.classList.remove(`os-theme`);
        }
      },
      deep: true,
    },
    getHours() {
      if (this.getHours) {
        this.$hours.popHours(this.getHours);
        this.openNow = this.$hours.isOpenNow();
        this.ot = this.$hours.openTime();
        this.ct = this.$hours.closeTime();
      } else {
        this.$hours.alwaysOpen = true;
      }
    },
  },
};
</script>
<style scoped lang="scss">
.closed {
  // background: linear-gradient(135deg, rgba(255, 193, 7, 0.1), rgba(255, 193, 7, 0.05));
  border-radius: 1rem;
  border: 0.15rem dashed var(--warning-colour);
  text-align: center;
  width: calc(100% - 3.3rem);
  margin: 0.5rem;
  padding: 2rem;
  .closed-inner {
    h1 {
      color: var(--warning-colour);
      margin: 0.5rem !important;
    }

    p {
      color: var(--text-colour);
      opacity: 0.8;
      font-size: 0.95rem;
    }

    text-align: center;
    margin: auto;
  }
}

.parent {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 1rem 1rem;

  .info {
    display: flex;
    justify-content: center;
    gap: 5px;
    width: 100%;

    .dark {
      filter: invert(1);
    }
    .light {
      filter: invert(0);
    }
    img {
      max-width: 40vw;
      display: block;
      margin-left: auto;
      margin-right: auto;
    }
    h2 {
      margin: 0;
    }

    p {
      margin: 0 0 0 1rem;
      text-decoration: none;
    }
  }
}
.info-end {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem;
  // background-color: #71717144;
  background-color: var(--secondary-colour);
  box-shadow: var(--box-shadow);
  .banner-item {
    display: flex;
    margin: 0.25rem;
    gap: 1rem;
    .text {
      text-align: right;
      h4 {
        color: var(--text-colour);
        margin: 0;
      }
      p {
        color: var(--text-colour);
        margin: 0;
        font-size: 0.7rem;
      }
    }
    .user-icon {
      cursor: pointer;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      flex-wrap: nowrap;
      background-color: var(--primary-colour);
      padding: 0.25rem 1rem;
      border-radius: 0.5rem;
      box-shadow: var(--box-shadow);
      color: var(--action-colour);
      .active {
        color: var(--tertiary-colour);
      }
      &:hover {
        background-color: var(--secondary-colour);
      }
      .icon {
        height: 1rem;
      }
    }
  }
}

.break {
  flex-basis: 100%;
  height: 0;
}

@media only screen and (orientation: portrait) {
  .info {
    img {
      max-width: 80vw !important;
    }
  }

  .closed {
    h1 {
      margin-top: 5rem;
      text-align: center;
    }
    p {
      text-align: center;
    }
  }

  .info-end {
    .banner-item {
      margin: 0.1rem;
      .text {
        text-align: center;
      }
      .user-icon {
        padding: 0.25rem 0.5rem;
      }
    }
  }
}
</style>
